module.exports = __webpack_public_path__ + "img/icon-2.2255fd9f.png";